import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import React from "react";

type modal = {
    open: boolean,
    Chilren: React.FC,
    // Returning `false` (or a Promise resolving to `false`) keeps the modal open
    // so handlers can short-circuit on validation failures. Any other return
    // value — including `undefined` from existing handlers — closes the modal.
    onConfirm?: (data?) => void | boolean | Promise<void | boolean>
    onClose?: (data?) => void
    onReject?: (data?) => void
    width?: string,
    hideModalFooter?: boolean
    showOneButton?: boolean
}

export type DownloadedModules = {
    projects: boolean,
    drawings: boolean,
    sequences: boolean,
    changeLogsTypes: boolean,
    changeLogs: boolean,
    disciplines: boolean,
    allUsers: boolean,
    comments: boolean,
    issues: boolean,
    status: boolean,
    categories: boolean,
    punchList: boolean,
    adHocUnits: boolean,
    models: boolean,
    punchListImages: boolean,
    readonlyelatedChecklistDetails: boolean,
    drilldownMappings: boolean,
    dd1Options: boolean,
    rootCauses: boolean,
    technology: boolean,
    linkDisciplineIssue: boolean,
    region: boolean,
    businessUnites: boolean,
    inspectionTaskLinks: boolean,
    onHoldCauses?: boolean,
    accessLevels: boolean
}

const initialState:
    {
        modal: modal,
        hasDownloaded: DownloadedModules,
        downloadTriggered: DownloadedModules,
        syncTriggered: boolean,
        disciplinePunchlistsImageDownloaded: { [downloaded: string]: boolean },
        disciplinePunchlistsImageTriggered: { [downloaded: string]: boolean },
        unsyncItemsCount: number,
        backClickHandler?: () => void,
        taskDisplayedPath: string,
        pendingPunchListCount: string | number,
        lastFetchedInspectionDisciplineId: number | null,

    } = {
    modal: {
        open: false,
        Chilren: () => "",
        onConfirm: (_?) => { },
        onClose: (_?) => { },
        width: null,
    },
    hasDownloaded: {
        linkDisciplineIssue: false,
        inspectionTaskLinks: false,
        drilldownMappings: false,
        dd1Options: false,
        projects: false,
        drawings: false,
        sequences: false,
        changeLogsTypes: false,
        changeLogs: false,
        disciplines: false,
        allUsers: false,
        comments: false,
        issues: false,
        status: false,
        categories: false,
        punchList: false,
        adHocUnits: false,
        models: false,
        readonlyelatedChecklistDetails: false,
        punchListImages: false,
        rootCauses: false,
        technology: false,
        region: false,
        businessUnites: false,
        onHoldCauses: false,
        accessLevels: false,
    },
    downloadTriggered: {
        projects: false,
        drawings: false,
        drilldownMappings: false,
        linkDisciplineIssue: false,
        inspectionTaskLinks: false,
        dd1Options: false,
        sequences: false,
        changeLogsTypes: false,
        changeLogs: false,
        disciplines: false,
        allUsers: false,
        comments: false,
        issues: false,
        status: false,
        categories: false,
        punchList: false,
        adHocUnits: false,
        models: false,
        readonlyelatedChecklistDetails: false,
        punchListImages: false,
        rootCauses: false,
        technology: false,
        region: false,
        businessUnites: false,
        accessLevels: false,
    },
    syncTriggered: false,
    disciplinePunchlistsImageDownloaded: {},
    disciplinePunchlistsImageTriggered: {},
    unsyncItemsCount: 0,
    backClickHandler: null,
    taskDisplayedPath: "childs",
    pendingPunchListCount: 0,
    lastFetchedInspectionDisciplineId: null,
}

const Units = createSlice({
    name: 'utilities',
    initialState,
    reducers: {
        setModalOpen: (state, action: PayloadAction<boolean>) => {
            state.modal.open = action.payload
        },
        setModalMessage: (state, action: PayloadAction<React.FC>) => {
            state.modal.Chilren = action.payload
        },
        setModal: (state, action: PayloadAction<modal>) => {
            state.modal = action.payload
        },
        updateHasDownloadedValue: (state, action: PayloadAction<{ key: keyof DownloadedModules, value: boolean }>) => {
            state.hasDownloaded[action.payload.key] = action.payload.value
        },
        updateDownloadTriggered: (state, action: PayloadAction<{ key: keyof DownloadedModules, value: boolean }>) => {
            state.downloadTriggered[action.payload.key] = action.payload.value
        },
        updatesyncTriggered: (state, action: PayloadAction<boolean>) => {
            state.syncTriggered = action.payload
        },
        addDisciplinesImagesFlag: (state, action: PayloadAction<string>) => {
            state.disciplinePunchlistsImageDownloaded[action.payload] = false
            state.disciplinePunchlistsImageTriggered[action.payload] = false
        },
        updateDisciplinesImagesFlag: (state, action: PayloadAction<{ disciplineCode: string, value: boolean }>) => {
            state.disciplinePunchlistsImageDownloaded[action.payload.disciplineCode] = action.payload.value
        },
        updateDisciplinesImagesTriggered: (state, action: PayloadAction<{ disciplineCode: string, value: boolean }>) => {
            state.disciplinePunchlistsImageTriggered[action.payload.disciplineCode] = action.payload.value
        },
        updateUnsyncItemsCount: (state, action: PayloadAction<number>) => {
            state.unsyncItemsCount = action.payload
        },
        setBackClickHandler: (state, action: PayloadAction<() => void>) => {
            state.backClickHandler = action.payload
        },
        setTaskDisplayedPath: (state, action: PayloadAction<string>) => {
            state.taskDisplayedPath = action.payload
        },
        updatePendingPunchListCount: (state, action: PayloadAction<number | string>) => {
            state.pendingPunchListCount = action.payload
        },
        setLastFetchedInspectionDisciplineId: (state, action: PayloadAction<number | null>) => {
            state.lastFetchedInspectionDisciplineId = action.payload
        }
    },
});

export const { setModalOpen, setModalMessage, setModal, addDisciplinesImagesFlag, updateDisciplinesImagesFlag,
    updateDisciplinesImagesTriggered, updateUnsyncItemsCount, updatePendingPunchListCount,
    updateHasDownloadedValue, updateDownloadTriggered, updatesyncTriggered, setBackClickHandler, setTaskDisplayedPath,
    setLastFetchedInspectionDisciplineId,
} = Units.actions;

export default Units.reducer;
